import InscreenObserver from '@finn-no/inscreen-observer';
import * as prometheus from '../tracking/prometheus';

const impressionObserver = new InscreenObserver(prometheus.logInscreen, {
    threshold: 0.5,
    timeout: 1000,
    once: true,
});

export function addInscreenEventsPrometheus(container: Element) {
    if (container) {
        impressionObserver.observe(container);
    }
}
